/**
 * Inspiration Block.
 * 
 */

/**
 * Desktop: Words slide in from right via gsap.
 * Mobile: Same behavior.
 */

const $ = jQuery;   // jQuery loaded via WordPress enqueue process

const gsap = require("gsap/dist/gsap").gsap;
const ScrollTrigger = require("gsap/dist/ScrollTrigger").ScrollTrigger;

gsap.registerPlugin(ScrollTrigger);

function initInspireText() {
	// console.log("INSPIRATION: initInspireText()");
	let
		$slides =  gsap.utils.toArray('.inspiration-block__inspiration');

	let tl = gsap.timeline({
		repeat:-1,
		scrollTrigger: {
			trigger: ".inspiration-block__inspirations",
			start: "top bottom",
			end: "bottom top",
			// id: "slides",
			// markers: true,
		}
	});

	$slides.forEach(function($slide, i) {
		// gsap.set($slide, {position: "absolute", top:0, xPercent:-50});

		// tl.from($slide, {autoAlpha:0, y: -100, ease:"bounce.out"}, i*1.5);
		// tl.to($slide, {autoAlpha:0, y:100, delay:1, ease:"power3.in"}, i*1.5);

		// FAST.
		// tl.from($slide, {autoAlpha:0, x:600, ease:"power3.out"}, i*1.5);
		// tl.to($slide, {autoAlpha:0, x:0, delay:1, ease:"power3.in"}, i*1.5);

		// NOT SO FAST.
		tl.to($slide, {
			autoAlpha:1,
			x:-600, 
			ease:"power3.out"
		}, i*2.5);
		tl.to($slide, {
			autoAlpha:0, 
			x:-600, 
			delay:2.0, 
			ease:"power3.in"
		}, i*2.5);
	});

}

exports.init = function () {
    // Run init methods...
    initInspireText();
};